/**
 * Sanitize an arbitrary value by replacing known sensitive keys with '[REDACTED]'.
 * Applied to every event body before it enters the queue.
 */
const BLOCKED_KEYS = new Set([
  'password',
  'token',
  'access_token',
  'secret',
  'key',
  'authorization',
  'refresh_token',
  'id_token',
  'client_secret'
]);

export function sanitize(value, _depth = 0) {
  if (_depth > 5 || value === null || value === undefined) return value;
  if (Array.isArray(value)) return value.map(v => sanitize(v, _depth + 1));
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [
        k,
        BLOCKED_KEYS.has(k.toLowerCase()) ? '[REDACTED]' : sanitize(v, _depth + 1)
      ])
    );
  }
  return value;
}
